module.exports = __webpack_public_path__ + "static/img/course-check.3d449eb0.png";